import { inject } from 'vue'

export const queueServiceKey = Symbol('queueService')

export function useQueueService() {
    const queueService = inject(queueServiceKey, null)

    if (!queueService) throw new Error('Queue service is not registered.')

    return queueService
}
